import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { LayoutService } from '@dgacontrol-frontend/sakai-ng';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AuthService } from '@dgacontrol-frontend/core';
import { MESSAGE_KEYS } from '@dgacontrol-frontend/shared/constants';

import { QUOTE_REQUESTS_LINK } from './admin-shell/quote-requests-menu';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [ConfirmationService],
})
export class AppComponent implements OnInit {
  title = 'dgacontrol-frontend-users';
  layoutService: LayoutService = inject(LayoutService);
  authService: AuthService = inject(AuthService);
  confirmationService: ConfirmationService = inject(ConfirmationService);
  protected readonly MESSAGE_KEYS = MESSAGE_KEYS;

  ngOnInit(): void {
    this.layoutService.appTitle.set('DGACONTROL - RESOLUCION 1238');
    this.layoutService.layoutConfig.update((c) => ({
      ...c,
      menuMode: 'static',
      darkTheme: true,
    }));

    // Topbar logout button (Sakai v21) → confirm before delegating to AuthService.requestLogout.
    this.layoutService.logoutRequested$.subscribe(() => {
      this.confirmationService.confirm({
        key: 'cdLogout',
        message: '¿Seguro que quiere cerrar sesión?',
        header: 'Cerrar sesión',
        icon: 'pi pi-sign-out',
        accept: () => {
          this.authService.requestLogout('manual');
        },
      });
    });
    const menu: MenuItem[] = [
      {
        label: 'Usuarios',
        items: [{ label: 'Registro', routerLink: ['users'] }],
      },
      {
        label: 'Network',
        items: [
          { label: 'Nodos', routerLink: ['network/nodes'] },
          {
            label: 'Gateways lorawan',
            routerLink: ['network/gateways-lorawan'],
          },
          {
            label: 'Routers',
            routerLink: ['network/routers'],
          },
        ],
      },
      {
        label: 'Dataloggers',
        items: [
          {
            label: 'Hardware',
            routerLink: ['dataloggers/hardware'],
          },
          {
            label: 'Masters RS485',
            routerLink: ['dataloggers/rs485-masters'],
          },
          {
            label: 'Registro',
            routerLink: ['dataloggers'],
          },
          {
            label: 'Logs',
            items: [
              {
                label: 'Uplinks rechazados',
                routerLink: ['dataloggers/rejected-uplinks'],
              },
              {
                label: 'Historial de downlink requests',
                routerLink: ['logs/downlink-requests'],
              },
            ],
          },
          {
            label: 'Celular',
            items: [
              {
                label: 'Operadores móviles',
                routerLink: ['cellular/mobile-operators'],
              },
              {
                label: 'Sims card',
                routerLink: ['cellular/simcards'],
              },
              {
                label: 'Planes Mint',
                routerLink: ['cellular/planes-mint'],
              },
            ],
          },
        ],
      },
      {
        label: 'Obras de captacion',
        items: [
          {
            label: 'Logs',
            items: [
              {
                label: 'Logs datos obra de captación',
                routerLink: ['logs/catchment-work-data-logs'],
              },
              {
                label: 'Logs downlink datos pendientes obra de captación',
                routerLink: [
                  'logs/catchment-work-logs-lora-downlink-get-pending-data',
                ],
              },
              {
                label: 'Listado de gaps',
                routerLink: ['logs/gaps'],
              },
            ],
          },
          {
            label: 'Enviar downlink para pedir datos pendientes',
            routerLink: ['pending-data/send-downlink'],
          },
        ],
      },
      {
        label: 'Configuraciones',
        items: [
          { label: 'Sistema', routerLink: ['configurations'] },
        ],
      },
      {
        label: 'Billing',
        items: [
          { label: 'Items', routerLink: ['billing/items'] },
          { label: 'Bundles', routerLink: ['billing/item-bundles'] },
          { label: 'Suscripciones', routerLink: ['billing/subscriptions'] },
          {
            label: 'Cobros a clientes',
            routerLink: ['billing/work-charges'],
          },
        ],
      },
      {
        label: 'Cotizaciones',
        items: [
          { label: 'Cotizaciones', routerLink: ['billing/quotes'] },
          // admin-shell writes the count of unattended requests into this label.
          { label: 'Solicitudes', routerLink: [QUOTE_REQUESTS_LINK] },
        ],
      },
      {
        label: 'Legal',
        items: [
          { label: 'Documentos', routerLink: ['legal/documents'] },
          { label: 'Aceptaciones', routerLink: ['legal/acceptances'] },
        ],
      },
      {
        label: 'Direcciones',
        items: [
          { label: 'Regiones', routerLink: ['geography/regions'] },
          { label: 'Comunas', routerLink: ['geography/communes'] },
        ],
      },
    ];

    this.layoutService.menuItems.set(menu);

    // Forward the reason: it is what lets `/login` explain the eviction instead of
    // bouncing the user back to the form with no account of why.
    this.authService.logoutRequested$.subscribe((reason) => {
      this.authService.logout(reason);
    });
  }
}
